import React, { useMemo, useRef } from 'react';
import { jpdRoadmapOnTimelineButtonEntryPoint } from '@atlassian/jira-roadmap-on-timeline/button/entrypoint.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { InwardIssue } from '@atlassian/jira-roadmap-on-timeline-utils/src/types.tsx';
import type { ParentWithStatus } from '../../../../state/selectors/header/filters/issue-parent-with-status/selectors.tsx';

type Props = { issueParents: ParentWithStatus[] };

export const JpdRoadmapExperimentButton = (props: Props) => {
	if (!fg('grw-880_jpd_roadmap_on_jira_timeline_killswitch')) {
		return null;
	}

	return <JpdRoadmapExperimentButtonInternal {...props} />;
};

const JpdRoadmapExperimentButtonInternal = ({ issueParents }: Props) => {
	const hasLoadedEntrypoint = useRef(false);
	const inwardIssues = useMemo(
		() => issueParents.map((issue): InwardIssue => ({ ...issue, issueType: 'epic' })),
		[issueParents],
	);
	const runtimeProps = useMemo(() => ({ inwardIssues }), [inwardIssues]);

	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		jpdRoadmapOnTimelineButtonEntryPoint,
		{},
	);

	if (!hasLoadedEntrypoint.current) {
		entryPointActions.load();
		hasLoadedEntrypoint.current = true;
	}

	return (
		<JiraEntryPointContainer
			id="growth.jpdRoadmapOnTimelineButton"
			packageName="jpd-roadmap-on-timeline-button"
			teamName="galileo-growth"
			runtimeProps={runtimeProps}
			entryPointReferenceSubject={entryPointReferenceSubject}
			fallback={null}
		/>
	);
};
